const ssn = {
    ssn : {
        value: "",
        dbqName: "form1[0].#subform[0].SSN[0]"
     },
     examDate: {
        value: "",
        dbqName: "form1[0].#subform[0].DateOfExam[0]"
    },
     docName: {
         value: "",
         dbqName: "form1[0].#subform[12].SectionXVI-ExaminersCertSign[0].TextField8[1]"
    },
     docDate: {
        value : "",
        dbqName: "form1[0].#subform[12].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
    docArea: {
        value: "",
        dbqName: "form1[0].#subform[12].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].#subform[12].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].#subform[12].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "form1[0].#subform[12].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].#subform[12].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses1[0]_fv",
            sides: {
                right: "form1[0].#subform[1].SideR1[0]_fv",
                left: "form1[0].#subform[1].SideL1[0]_fv",
                both: "form1[0].#subform[1].SideB1[0]_fv",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR1[0]_fv",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL1[0]_fv"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses2[0]",
            sides: {
                right: "form1[0].#subform[1].SideR2[0]",
                left: "form1[0].#subform[1].SideL2[0]",
                both: "form1[0].#subform[1].SideB2[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR2[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL2[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses3[0]",
            sides: {
                right: "form1[0].#subform[1].SideR3[0]",
                left: "form1[0].#subform[1].SideL3[0]",
                both: "form1[0].#subform[1].SideB3[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR3[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL3[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses4[0]",
            sides: {
                right: "form1[0].#subform[1].SideR4[0]",
                left: "form1[0].#subform[1].SideL4[0]",
                both: "form1[0].#subform[1].SideB4[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR4[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL4[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses5[0]",
            sides: {
                right: "form1[0].#subform[1].SideR5[0]",
                left: "form1[0].#subform[1].SideL5[0]",
                both: "form1[0].#subform[1].SideB5[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR5[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL5[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses6[0]",
            sides: {
                right: "form1[0].#subform[1].SideR6[0]",
                left: "form1[0].#subform[1].SideL6[0]",
                both: "form1[0].#subform[1].SideB6[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR6[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL6[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses7[0]",
            sides: {
                right: "form1[0].#subform[1].SideR7[0]",
                left: "form1[0].#subform[1].SideL7[0]",
                both: "form1[0].#subform[1].SideB7[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR7[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL7[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses9[0]",
            sides: {
                right: "form1[0].#subform[1].SideR9[0]",
                left: "form1[0].#subform[1].SideL9[0]",
                both: "form1[0].#subform[1].SideB9[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR9[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL9[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses10[0]",
            sides: {
                right: "form1[0].#subform[1].SideR10[0]",
                left: "form1[0].#subform[1].SideL10[0]",
                both: "form1[0].#subform[1].SideB10[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR10[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL10[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses11[0]",
            sides: {
                right: "form1[0].#subform[1].SideR11[0]",
                left: "form1[0].#subform[1].SideL11[0]",
                both: "form1[0].#subform[1].SideB11[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR11[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL11[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses101b[0]",
            sides: {
                right: "form1[0].#subform[1].SideR101b[0]",
                left: "form1[0].#subform[1].SideL101b[0]",
                both: "form1[0].#subform[1].SideB101b[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR101b[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL101b[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses16[0]",
            sides: {
                right: "form1[0].#subform[1].SideR16[0]",
                left: "form1[0].#subform[1].SideL16[0]",
                both: "form1[0].#subform[1].SideB16[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR16[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL16[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses38[0]",
            sides: {
                right: "form1[0].#subform[1].SideR38[0]",
                left: "form1[0].#subform[1].SideL38[0]",
                both: "form1[0].#subform[1].SideB38[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR38[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL38[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses17[0]",
            sides: {
                right: "form1[0].#subform[1].SideR17[0]",
                left: "form1[0].#subform[1].SideL17[0]",
                both: "form1[0].#subform[1].SideB17[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR17[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL17[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses18[0]",
            sides: {
                right: "form1[0].#subform[1].SideR18[0]",
                left: "form1[0].#subform[1].SideL18[0]",
                both: "form1[0].#subform[1].SideB18[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR18[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL18[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses19[0]",
            sides: {
                right: "form1[0].#subform[1].SideR19[0]",
                left: "form1[0].#subform[1].SideL19[0]",
                both: "form1[0].#subform[1].SideB19[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR19[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL19[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses20[0]",
            sides: {
                right: "form1[0].#subform[1].SideR20[0]",
                left: "form1[0].#subform[1].SideL20[0]",
                both: "form1[0].#subform[1].SideB20[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR20[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL20[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses21[0]",
            sides: {
                right: "form1[0].#subform[1].SideR21[0]",
                left: "form1[0].#subform[1].SideL21[0]",
                both: "form1[0].#subform[1].SideB21[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR21[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL21[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses22[0]",
            sides: {
                right: "form1[0].#subform[1].SideR22[0]",
                left: "form1[0].#subform[1].SideL22[0]",
                both: "form1[0].#subform[1].SideB22[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR22[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL22[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses23[0]",
            sides: {
                right: "form1[0].#subform[1].SideR23[0]",
                left: "form1[0].#subform[1].SideL23[0]",
                both: "form1[0].#subform[1].SideB23[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR23[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL23[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses25[0]",
            sides: {
                right: "form1[0].#subform[1].SideR25[0]",
                left: "form1[0].#subform[1].SideL25[0]",
                both: "form1[0].#subform[1].SideB25[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR25[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL25[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses26[0]",
            sides: {
                right: "form1[0].#subform[1].SideR26[0]",
                left: "form1[0].#subform[1].SideL26[0]",
                both: "form1[0].#subform[1].SideB26[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR26[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL26[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses27[0]",
            sides: {
                right: "form1[0].#subform[1].SideR27[0]",
                left: "form1[0].#subform[1].SideL27[0]",
                both: "form1[0].#subform[1].SideB27[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR27[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL27[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses273[0]",
            sides: {
                right: "form1[0].#subform[1].BonesMalignantRight[0]",
                left: "form1[0].#subform[1].BonesMalignantLeft[0]",
                both: "form1[0].#subform[1].BonesMalignantBoth[0]",
                rightDateDbqName: "form1[0].#subform[1].BonesMalignantRDate[0]",
                leftDateDbqName: "form1[0].#subform[1].BonesMalignantLDate[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses28[0]",
            sides: {
                right: "form1[0].#subform[1].SideR28[0]",
                left: "form1[0].#subform[1].SideL28[0]",
                both: "form1[0].#subform[1].SideB28[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR28[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL28[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses29[0]",
            sides: {
                right: "form1[0].#subform[1].SideR29[0]",
                left: "form1[0].#subform[1].SideL29[0]",
                both: "form1[0].#subform[1].SideB29[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR29[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL29[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses31[0]",
            sides: {
                right: "form1[0].#subform[1].SideR31[0]",
                left: "form1[0].#subform[1].SideL31[0]",
                both: "form1[0].#subform[1].SideB31[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR31[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL31[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses33[0]",
            sides: {
                right: "form1[0].#subform[1].SideR33[0]",
                left: "form1[0].#subform[1].SideL33[0]",
                both: "form1[0].#subform[1].SideB33[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR33[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL33[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses35[0]",
            sides: {
                right: "form1[0].#subform[1].SideR35[0]",
                left: "form1[0].#subform[1].SideL35[0]",
                both: "form1[0].#subform[1].SideB35[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR35[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL35[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Diagnoses36[0]",
            sides: {
                right: "form1[0].#subform[1].SideR36[0]",
                left: "form1[0].#subform[1].SideL36[0]",
                both: "form1[0].#subform[1].SideB36[0]",
                rightDateDbqName: "form1[0].#subform[1].DateOfDiagnosisR36[0]",
                leftDateDbqName: "form1[0].#subform[1].DateOfDiagnosisL36[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Tendinitis1B[0]",
            sides: {
                right: "form1[0].#subform[1].Tendinitis1BRight[0]",
                left: "form1[0].#subform[1].Tendinitis1BLeft[0]",
                both: "form1[0].#subform[1].Tendinitis1BBoth[0]",
                rightDateDbqName: "form1[0].#subform[1].Tendinitis1BRDate[0]",
                leftDateDbqName: "form1[0].#subform[1].Tendinitis1BLDate[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Tendinosis1B[0]",
            sides: {
                right: "form1[0].#subform[1].Tendinosis1BRight[0]",
                left: "form1[0].#subform[1].Tendinosis1BLeft[0]",
                both: "form1[0].#subform[1].Tendinosis1BBoth[0]",
                rightDateDbqName: "form1[0].#subform[1].Tendinosis1BRDate[0]",
                leftDateDbqName: "form1[0].#subform[1].Tendinosis1BLDate[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[1].Tenosynovitis1B[0]",
            sides: {
                right: "form1[0].#subform[1].Tenosynovitis1BRight[0]",
                left: "form1[0].#subform[1].Tenosynovitis1BLeft[0]",
                both: "form1[0].#subform[1].Tenosynovitis1BBoth[0]",
                rightDateDbqName: "form1[0].#subform[1].Tenosynovitis1BRDate[0]",
                leftDateDbqName: "form1[0].#subform[1].Tenosynovitis1BLDate[0]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[2].OtherDiagnosis1[0]",
            sides: {
                right: "form1[0].#subform[2].SideR12[0]",
                left: "form1[0].#subform[2].SideL12[0]",
                both: "form1[0].#subform[2].SideB12[0]",
                rightDateDbqName: "form1[0].#subform[2].DateOfDiagnosisR12[0]",
                leftDateDbqName: "form1[0].#subform[2].DateOfDiagnosisL12[0]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[2].OtherDiagnosis2[0]",
            sides: {
                right: "form1[0].#subform[2].SideR13[0]",
                left: "form1[0].#subform[2].SideL13[0]",
                both: "form1[0].#subform[2].SideB13[0]",
                rightDateDbqName: "form1[0].#subform[2].DateOfDiagnosisR13[0]",
                leftDateDbqName: "form1[0].#subform[2].DateOfDiagnosisL13[0]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[2].OtherDiagnosis3[0]",
            sides: {
                right: "form1[0].#subform[2].SideR14[0]",
                left: "form1[0].#subform[2].SideL14[0]",
                both: "form1[0].#subform[2].SideB14[0]",
                rightDateDbqName: "form1[0].#subform[2].DateOfDiagnosisR14[0]",
                leftDateDbqName: "form1[0].#subform[2].DateOfDiagnosisL14[0]"
            },
        }     
    ]
}

export default ssn ;